import { State, Action, StateContext, Actions, ofActionSuccessful } from '@ngxs/store';
import { StoreSourceInfos, GetIssuers, GetProducts, StoreResource, StoreInfoUser } from './app.actions';
import { Injectable } from '@angular/core';
import { Dispatcher } from './base/dispatcher';
import { LocalStorageService } from 'ngx-webstorage';
import { EventManager, UserService } from '../core';
import { AppsService } from '../shared/services/apps.service';
declare let $: any;
export interface AppStateModel {
    userProfile: any;
    sourceInfos: any;
    resources: any;
    issuers: any;
    products: any;
}

export function initAppState(): AppStateModel {
    return {
        issuers: [],
        products: []
    } as AppStateModel;
}

@State<AppStateModel>({
    name: 'App',
    defaults: initAppState()
})
@Injectable()
export class AppState {

    constructor(
        private actions$: Actions,
        private dispatcher: Dispatcher,
        private aAppsService: AppsService,
        private localStorage$: LocalStorageService,
        public eventManger: EventManager,
    ) { }

    @Action(StoreInfoUser)
    StoreInfoUser(ctx: StateContext<AppStateModel>, action: StoreInfoUser) {
        const userProfile = action.payload;
        ctx.patchState({
            userProfile
        });
    }
    @Action(StoreSourceInfos)
    StoreSourceInfos(ctx: StateContext<AppStateModel>, action: StoreSourceInfos) {
        const sourceInfos = action.payload;
        ctx.patchState({
            sourceInfos
        });
    }
    @Action(StoreResource)
    StoreResource(ctx: StateContext<AppStateModel>, action: StoreResource) {
        return this.aAppsService.getResources()
        .subscribe((res: any) => {
            const resources = res.body.data || {};
            ctx.patchState({
                resources
            });
        });
    }
    @Action(GetProducts)
    GetProducts(ctx: StateContext<AppStateModel>, action: GetProducts) {
        let body = {
            page: 1,
            pageSize: 250,
            types: ["NEW_FUND", "TRADING_FUND"]
        };
        const products = Object.assign({}, ctx.getState().products || {});
        if (products.length) {
            return;
        }
    }
}
